<template>
  <div class="sidebar-container">
    <ul>
      <li>
        <router-link to="/">
          <img src="@/assets/logo-alt.png" />
        </router-link>
      </li>
      <li v-for="route of routes" :class="{active: $route.name == route.name}" :key="route.name">
        <router-link :to="{path: '/admin-maps/' + route.path, query: {periodId: periodId}}">
          <font-awesome-icon :icon="route.meta.icon" class="icon"></font-awesome-icon>
          {{route.meta.title}}
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: "AdminMapsSidebar",
    props: ["periodId"],
    data() {
      return {
        routes: [],
        login: "",
        email: "",
        autologinHash: ""
      }
    },
    mounted() {
      this.login = new URL(window.location.href).searchParams.get("login");
      this.email = new URL(window.location.href).searchParams.get("email");
      this.autologinHash = new URL(window.location.href).searchParams.get("autologinHash");

      const adminRoute = this.$router.options.routes.find(r => r.path == "/admin-maps");
      if (!adminRoute) return;
      this.routes = adminRoute.children;
    }
  }
</script>

<style scoped>
  .sidebar-container {
    min-height: 100%;
    background-color: white;
    padding: 12px 8px;
  }

  ul {
    width: 100%;
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    row-gap: 12px;
  }

  li {
    margin: 0;
    padding: 0;
    width: 100%;
    font-size: 16px;
  }
  li a {
    text-decoration: none;
    color: inherit;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    transition: all ease 230ms;
    text-align: center;
  }

  li img {
    max-width: 75%;
    margin-bottom: 32px;
  }

  li .icon, li svg {
    width: 24px;
    height: auto;
    color: #CCC;
    transition: all ease 230ms;
  }

    li:hover,
    li:hover .icon,
    li.active,
    li.active .icon {
      color: #7ED321;
    }
</style>



// WEBPACK FOOTER //
// src/components/AdminMapsSidebar.vue